export default __webpack_public_path__ + "static/media/man1.ffbcdeb4.png";